import * as React from 'react'
import {
  Action,
  any,
  async,
  fromJSX,
  nothing,
  stateful
} from 'widgets-for-react'
import {
  MarkAsNoViolationResponse,
  MarkAsViolationResponse
} from './contentAuditSuspectsApi'
import { ContentAuditSuspectsLayout } from './contentAuditSuspectsLayout'

import {
  contentAuditSuspectsUpdaters,
  ContentAuditSuspectUser,
  initialState,
  PagedContentAuditSuspects,
  Props,
  State
} from './contentAuditSuspectsState'

export const root = (props: Props) =>
  stateful<State>({ key: 'content-audit-suspect' })(s0 =>
    any<Action<State>>()([
      s0.kind === 'loading'
        ? async<PagedContentAuditSuspects>()(s0.suspects).map(a =>
            contentAuditSuspectsUpdaters.onSuspectsUpdate(a)
          )
        : nothing(),
      s0.kind === 'loaded' && s0.decision.v.kind === 'r'
        ? any<Action<State>>()([
            s0.decision.v.v.kind === 'violation'
              ? any<Action<State>>()([
                  async<MarkAsViolationResponse>()(
                    s0.decision.v.v.value.markViolation
                  ).map(a =>
                    contentAuditSuspectsUpdaters.onMarkViolationUpdate(a)
                  ),
                  async<ContentAuditSuspectUser>()(
                    s0.decision.v.v.value.user
                  ).map(a =>
                    contentAuditSuspectsUpdaters.onSuspectUserUpdate(a)
                  )
                ])
              : nothing(),
            s0.decision.v.v.kind === 'no_violation'
              ? async<MarkAsNoViolationResponse>()(
                  s0.decision.v.v.value.markNoViolation
                ).map(a =>
                  contentAuditSuspectsUpdaters.onMarkNoViolationUpdate(a)
                )
              : nothing()
          ])
        : nothing(),
      fromJSX(setState => (
        <ContentAuditSuspectsLayout
          state={s0}
          onPageChange={i =>
            setState(contentAuditSuspectsUpdaters.onPageChange(_ => i))
          }
          onFilterChange={x =>
            setState(contentAuditSuspectsUpdaters.onFilterChange(x))
          }
          onToggleNoViolationForm={x =>
            setState(
              contentAuditSuspectsUpdaters.onToggleMarkNoViolationForm(x)
            )
          }
          onToggleMarkViolationForm={x =>
            setState(contentAuditSuspectsUpdaters.onToggleMarkViolationForm(x))
          }
          onToggleStrike={x => {
            setState(contentAuditSuspectsUpdaters.onToggleStrike(_ => x))
          }}
          onViolationSubmit={() => {
            setState(contentAuditSuspectsUpdaters.onViolationSubmit())
          }}
          onNoViolationSubmit={() => {
            setState(contentAuditSuspectsUpdaters.onNoViolationSubmit())
          }}
        />
      ))
    ]).map(a => a(s0))
  )(initialState(props))
